<template>
    <div class="card" style="min-height: 200px;">
        <div class="card-modal">
            <div v-if="loading">
                <b-loading :is-full-page="false" :active="loading" :can-cancel="true"></b-loading>
            </div>
            <div v-else>
                <header class="modal-card-head">
                    <p class="modal-card-title">Record Locator {{ recordLocator }}</p>
                    <button type="button" class="delete" @click="$emit('close')" />
                </header>
                <section class="modal-card-body">
                    <b-tabs position="is-centered" class="policy-modal-tabs-ul">
                        <b-tab-item v-for="(categoryData, category) in ruleCategories" :key="category"
                            :icon="categoryData.icon" :label="$helpers.capitalize(category)">
                            <div class="my-3">
                                <h3 class="is-size-5 mb-3">
                                    Rules Violated
                                </h3>
                                <ul>
                                    <li v-for="rule in categoryData.violatedRules" :key="rule.id">
                                        <span class="is-capitalized">{{ rule.message }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="categoryData.violationNotes.length > 0">
                                <h3 class="is-size-5 mb-3">
                                    Violation Notes
                                </h3>
                                <ul>
                                    <li v-for="note in categoryData.violationNotes" :key="note.id">
                                        <span class="is-capitalized">{{ note.message }}</span>
                                    </li>
                                </ul>

                            </div>
                        </b-tab-item>
                    </b-tabs>
                </section>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TripPolicyViolationModal',
    props: {
        violationNotes: {
            required: false,
            type: Array,
        },
        rulesTriggered: {
            required: true,
            type: Array,
        },
        recordLocator: {
            required: true,
            type: String,
        },
        travelerProfileRecordLocator: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            policyRules: [],
            loading: true,
            ruleCategories: {}
        };
    },
    methods: {
        async fetchRuleSingle() {
            const fetchPromises = this.rulesTriggered.map(triggeredId => {
                const body = {
                    travelPolicyRuleId: triggeredId,
                };
                return this.$app.huddleLabsServerCall("profile/travel-policy/rule", body)
                    .then(result => {
                        if (!result.error && result.data) {
                            this.policyRules.push(result.data);
                        }
                    });
            });

            // Wait for all fetches to complete
            await Promise.all(fetchPromises);

            // Now call extractViolatedRules
            this.extractViolatedRules();
        },
        fetchRules() {
            const body = {
                amadeusTravelerProfileRecordLocator: this.travelerProfileRecordLocator,
                includeRelated: ["travelPolicy"],
            };
            this.$app.huddleLabsServerCall("profile/travel-profile", body)
                .then(result => {
                    if (!result.error && result.data.travelPolicy) {
                        this.policyRules = result.data.travelPolicy.rules;
                        this.extractViolatedRules();
                    } else {
                        this.fetchRuleSingle();
                    }
                    this.loading = false;
                });
        },
        extractViolatedRules() {
            const ruleCategories = {};

            // Remove duplicates from the rulesTriggered array
            const uniqueRules = [...new Set(this.rulesTriggered)];

            // Process violated rules
            uniqueRules.forEach((triggeredId) => {
                let matchedRule = this.policyRules.find((rule) =>
                    rule.id.toLowerCase() === triggeredId.toLowerCase()
                );

                if (matchedRule) {
                    if (!ruleCategories[matchedRule.category]) {
                        ruleCategories[matchedRule.category] = {
                            icon: this.getCategoryIcon(matchedRule.category),
                            violatedRules: [],
                            violationNotes: []
                        };
                    }
                    ruleCategories[matchedRule.category].violatedRules.push({
                        id: matchedRule.id,
                        category: matchedRule.category,
                        message: matchedRule.triggeredMessage,
                    });
                }
            });

            // Process violation notes
            this.violationNotes.forEach((violationNote, index) => {
                let parts = violationNote.split("|");
                let type = parts[0].toLowerCase();
                let message = parts[1].toLowerCase();

                if (!ruleCategories[type]) {
                    ruleCategories[type] = {
                        icon: this.getCategoryIcon(type),
                        violatedRules: [],
                        violationNotes: []
                    };
                }

                // Use the timestamp (or index) to generate a unique ID for the violation note
                const uniqueId = `${type}-${Date.now()}-${index}`;

                ruleCategories[type].violationNotes.push({
                    id: uniqueId,  // Unique ID generated by combining type and timestamp/index
                    category: type,
                    message: message,
                });
            });

            this.ruleCategories = ruleCategories;
        },
        getCategoryIcon(category) {
            if (category === 'air') return 'airplane';
            if (category === 'car') return 'car-hatchback';
            if (category === 'hotel') return 'bed';
            return 'wallet-travel';
        },
    },
    mounted() {
        this.fetchRules();
    }
};
</script>
<style>
.policy-modal-tabs-ul .tabs.is-centered ul {
    margin-left: 0;
}
</style>
